// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import date from 'zdate';
import {i_zone_session} from './types';
import {Proxy_type, t_order} from '../../../../hola/pub/ui/pro/cp/orders';

const status_map: {[key: string]: i_zone_session['status']} = {
    taken: 'Running',
    running: 'Running',
    queued: 'Running',
    failed: 'Failed',
    finalized: 'Finalized',
    Running: 'Running',
    awaiting: 'Awaiting',
    Awaiting: 'Awaiting',
    Finalized: 'Finalized',
    Failed: 'Failed',
};

export const format_sessions = sessions=>{
    return sessions.map(s=>{
        const started_ts = date(s.taken_ts || s.insert_ts);
        return {
            ...s,
            status: status_map[s.status] || 'Unknown',
            started_ts: started_ts,
            started_ms: started_ts.getTime(),
            started_fmt: date.strftime('%d %b, %r', started_ts),
            id_cropped: (s._id+'').slice(0, 7),
            id: s._id,
        };
    });
};

export const fake_project: t_order = {
    _id: 'first_project',
    name: 'Project_1',
    type: Proxy_type.SCR,
    zone: '',
    client_id: '',
    until: '',
    start: '',
    limit: 2,
    generated_proxies: [{
        ip: '',
        host: 'brd.superproxy.io',
        port: '9***',
        login: 'usernamej****',
        password: '4lly5f9jxen****',
        country: '',
        socks5: false,
        port_selenium: '9***',
    }],
    config: {
        premium_domains: false,
        captcha_solver: false,
        passwords: [],
        allowed_ips: [],
        blocked_ips: [],
        allowed_target_hosts: [],
        blocked_target_hosts: [],
        special_ports: false,
        custom_headers_and_cookies: false,
        usage_limit: {
            limit: 1000000,
            limit_kind: 'gb',
            currency: '',
            period: 'day',
            exceed_action: 'alert'
        }
    }
};
